import { render, staticRenderFns } from "./ResourcesEditor.vue?vue&type=template&id=68992646&scoped=true"
import script from "./ResourcesEditor.vue?vue&type=script&lang=js"
export * from "./ResourcesEditor.vue?vue&type=script&lang=js"
import style0 from "./ResourcesEditor.vue?vue&type=style&index=0&id=68992646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68992646",
  null
  
)

export default component.exports